import React from 'react';
import UploadManager from 'components/UploadManager';

const BulkUpdateUploads = () =>
  <UploadManager
    uploadType="bulk_update_uploads"
    title="Bulk Update"
  />;

export default BulkUpdateUploads;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/bulkUpdateUploads/index.jsx